module.exports = __webpack_public_path__ + "static/media/GersPrinciples.5592fa53.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/BannerItems/Contents/GersPrinciples.md
// module id = 1715
// module chunks = 0